import React, { useState } from 'react';
import ArticleMeta from '../../components/article-meta/ArticleMeta';

type ArticleDetailsArticleCardType = {
  tagLink: string;
  tagTitle: string;
  articleId: string;
  articleLink: string;
  articleTitle: string;
  articlePublishDate: string;
  articleReadingTime: string;
  articleImage: string;
  isBookmarked: boolean;
  bookmarkIds: number[];
};

const ArticleDetailsArticleCard = ({
  tagLink,
  tagTitle,
  articleId,
  articleLink,
  articleTitle,
  articlePublishDate,
  articleReadingTime,
  articleImage,
  isBookmarked,
}: ArticleDetailsArticleCardType) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <div className="article">
        <div className="article__content-wrapper">
          <div className="article__content-top">
            <a href={tagLink} className="tag-link">
              <div className="tag">
                <div className="tag__text">{tagTitle}</div>
              </div>
            </a>
            <a
              href={articleLink}
              className={`article__title-link ${isHovered ? 'hovered' : ''}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <h6 className="heading h6-noto" dangerouslySetInnerHTML={{ __html: articleTitle }} />
            </a>
          </div>
          <div className="article__content-bottom">
            <div className="article__info">
              <ArticleMeta
                articleData={{
                  id: articleId,
                  title: articleTitle,
                  url: articleLink,
                  image: articleImage,
                  publishDate: articlePublishDate,
                  readTime: articleReadingTime,
                  isPremium: false,
                }}
              />
            </div>
          </div>
        </div>

        <a
          href={articleLink}
          target="_blank"
          rel="noopener noreferrer"
          className="article__image-wrapper"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <img width="500" height="288" src={articleImage} className="article__image" alt="article" decoding="async" />
        </a>
      </div>
    </>
  );
};

export default ArticleDetailsArticleCard;
